import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../../constants/routes'

import CreateCommission from './create'
import ViewCommission from './view'
import ListCommissions from './list'

const CommissionsIndex = (props) => {
    return (
        <Routes>
            <Route path={nestedRoutePath(routes.commissionsIndex, routes.commissionsCreate)} element={<CreateCommission />} />
            <Route path={nestedRoutePath(routes.commissionsIndex, routes.commissionsView)} element={<ViewCommission />} />
            <Route index element={<ListCommissions />} />

        </Routes>
    )
}

export default CommissionsIndex
